import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable()
export class OcrService {

  constructor(private api: ApiService) { }

  extractDetails(data) {

    return this.api.post('ocr/extract', data);

  }

  autoVerifyDl(data) {
    return this.api.postApi('/ocr/licence', data);
  }

  autoVerifyPan(data) {
    return this.api.postApi('/ocr/pan', data);
  }

  submitAddress(data)
  {
    return this.api.post('ocr/address', data);
   }

}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/core/services/ocr.service.ts